import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkLinkDealerConfigOption } from '../services/dealerConfigOptions';
import { dealerConfigOptionKeys } from './useDealerConfigOptionsQuery';

export function useBulkLinkDealerConfigOptionMutation(optionId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (opts: { force?: boolean } = {}) => bulkLinkDealerConfigOption(optionId!, opts),
    onSuccess: () => {
      if (optionId) qc.invalidateQueries({ queryKey: dealerConfigOptionKeys.detail(optionId) });
    },
  });
}
